import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stbyAddress',
})
export class AddressPipe implements PipeTransform {
    transform(value: any): string {
        const address: string[] = [];
        const country: string[] = [];

        const addressTrimmed = value?.address?.trim();
        const postCodeTrimmed = value?.post_code?.trim();
        const cityTrimmed = value?.city?.trim();

        if (!addressTrimmed) return null;

        address.push(addressTrimmed);

        if (postCodeTrimmed) {
            country.push(postCodeTrimmed);
        }
        if (cityTrimmed) {
            country.push(cityTrimmed);
        }
        if (country.length) {
            address.push(country.join(' '));
        }

        return address.join(', ');
    }
}
